import { DataTableDefinition } from "@/v2/types/Datatable";
import { createColumnHelper, flexRender } from "@tanstack/react-table";
import { buildColumns } from "./buildColumns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";
import { generateFilterColumn } from "../../filter";
import { Project } from "@/v2/types";
import AccessControl from "../../rbac/AccessControl";
import ProjectDeleteButton from "../../ui/button/delete/Project";
import EditProject from "@/v2/page/project/Edit";

type T = Project;

const columnHelper = createColumnHelper<T>();

const ProjectColumnDefinition: DataTableDefinition<T>[] = [
    {
        id: "sl",
        headingText: "Sl No",
        headingCellType: "small-cell",
        cellType: "text-center",
    },
    {
        id: "name",
        headingText: "Name",
    },
    {
        id: "client.full_name",
        headingText: "Client Name",
    },

    {
        id: "location",
        headingText: "Project Location",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "client_rate",
        headingText: "Client Rate",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "client_commission",
        headingText: "Client Commission",
        headingCellType: "text-center",
        cellType: "text-center",
    },
    {
        id: "client_representative.full_name",
        headingText: "Client Representative",
        headingCellType: "text-center",
    },
    {
        id: "client_location",
        headingText: "Client Location",
        headingCellType: "text-center",
    },
    {
        id: "ar_coordinator.full_name",
        headingText: " Coordinator",
        headingCellType: "text-center",
    },

    {
        id: "actions",
        headingText: "Actions",
        headingCellType: "text-center",
        cell: ({ row }) =>
            flexRender(
                <div className="flex justify-center gap-2">
                    <Link to={`/projects/${row.id}`}>
                        <Button variant={"outline"} size={"sm"}>
                            <Eye className="size-4" />
                        </Button>
                    </Link>

                    <AccessControl
                        module="MOBILIZATION_MANAGEMENT"
                        requestedAccess={"PUT"}
                    >
                        <EditProject id={row.id} />
                    </AccessControl>

                    <AccessControl
                        module="MOBILIZATION_MANAGEMENT"
                        requestedAccess={"DELETE"}
                    >
                        <ProjectDeleteButton id={row.id} />
                    </AccessControl>
                </div>,
                {},
            ),
    },
];

const ProjectColumn = buildColumns<T>(columnHelper, ProjectColumnDefinition);

const ProjectFilterColumn = generateFilterColumn<T>(ProjectColumnDefinition, {
    addFilterId: {
        "client.full_name": "clients.full_name",
        "ar_coordinator.full_name": "ar_coordinators.full_name",
    },
});

export { ProjectColumn, ProjectFilterColumn };
